import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServerError() {
  const { t } = useTranslation('errors');

  return (
    <div className="min-h-screen bg-surface-light dark:bg-surface-dark flex items-center justify-center px-4 font-sans transition-colors duration-200">
      <div className="max-w-md w-full text-center animate-in fade-in zoom-in duration-700">
        {/* 500 Number */}
        <div className="mb-2">
          <h1 className="text-[12rem] font-black leading-none tracking-tighter text-state-danger-bg-light dark:text-state-danger-bg-dark/20 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none">
            500
          </h1>
          <div className="relative z-10">
            <div className="mx-auto w-24 h-24 bg-state-danger-light dark:bg-state-danger-dark rounded-3xl flex items-center justify-center shadow-2xl shadow-state-danger-light/20 dark:shadow-none mb-8">
              <svg
                className="w-12 h-12 text-on-accent-light dark:text-on-accent-dark"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="relative z-10">
          <h2 className="text-3xl font-black text-slate-900 dark:text-white mb-3 tracking-tight">
            {t('500.title')}
          </h2>
          <p className="text-text-muted-light dark:text-text-muted-dark font-medium mb-10 leading-relaxed">
            {t('500.description')}
          </p>

          {/* Support Info */}
          <div className="bg-surface-card-light dark:bg-surface-card-dark border border-surface-border-light dark:border-surface-border-dark p-6 rounded-2xl shadow-soft mb-10 text-left">
            <p className="text-[10px] font-black uppercase tracking-[0.2em] text-text-subtle-light dark:text-text-subtle-dark mb-4">
              {t('500.supportHeading')}
            </p>
            <div className="space-y-4">
              <div>
                <p className="text-xs font-bold text-text-subtle-light dark:text-text-subtle-dark uppercase mb-1">
                  {t('500.supportChannel')}
                </p>
                <a
                  href="mailto:support@pgkb.com"
                  className="inline-flex min-h-11 items-center text-sm font-bold text-brand-600 dark:text-brand-400 hover:underline"
                >
                  support@pgkb.com
                </a>
              </div>
              <div className="pt-4 border-t border-surface-border-light dark:border-surface-border-dark">
                <Link
                  to="/dashboard"
                  className="flex min-h-11 items-center gap-2 text-xs font-black uppercase tracking-widest text-text-muted-light dark:text-text-muted-dark hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  {t('500.dashboardLink')}
                </Link>
              </div>
            </div>
          </div>

          {/* Retry Button */}
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center px-8 py-3.5 bg-slate-900 dark:bg-white text-white dark:text-slate-900 text-sm font-black uppercase tracking-widest rounded-xl shadow-lg hover:opacity-90 transition-all active:scale-95"
          >
            {t('500.retry')}
          </button>
        </div>
      </div>
    </div>
  );
}
